<template>
  <router-link v-bind="$attrs" v-on="$listeners" :to="to" class="app-link">
    <slot />
    <span class="app-link__title">{{ text }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'AppRouterLink',

  props: {
    to: {
      type: Object,
      required: true,
    },

    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.app-link {
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  color: var(--c-primary);
}
</style>
